$( document ).ready(function() {
       
  var price = $(".product-detail_price-element").html();  
  //$(".detail-price").hide(); 
    var printerGetInt = setInterval(function(){
//console.log('dddd');
      if($(".UDprinterSelectBox .printer").length > 0 || $(".UDprinterSelectBox .printers").length > 0){
        $(".UDprinterSelectBox .colour").hide();
        $(".UDvariantContain div, .UDcartActionBtn").hide();
      	$(".UDprinterSelectBox .printer select").prepend('<option value="0" selected>Please select...</option>')
        $(".UDprinterSelectBox").show();
        $(".UDprinterSelectBox .printer select").addClass("UDprinterSlectOpt");
        clearInterval(printerGetInt);
      }
    },1000);
  
    $(document).on("change",".UDprinterSlectOpt",function(){
      	$(".detail-price").show();
      	if(this.value == 0){
          $(".UDvariantContain div, .UDcartActionBtn").hide();          
          $(".UDprinterSelectBox, .UDprinterSelectBox .printer").show();           
          $(".UDvariantContain .swt-type-image .available,.UDvariantContain .swt-type-color  .available").show();
          $(".UDvariantContain .swt-type-button  .available").show();
          $(".product-detail_price-element").html(price); 
        }else{
          $(".UDvariantContain div, .UDcartActionBtn").show();
          $(".UDvariantContain .swt-type-image .soldout,.UDvariantContain .swt-type-color  .soldout").hide();
          $(".UDvariantContain .swt-type-button  .soldout").hide();          
          $(".UDvariantContain .swt-type-image .available,.UDvariantContain .swt-type-color  .available").show();
          $(".UDvariantContain .swt-type-button  .available").show();
          $(".product-detail_price-element").html(price);         
          if($(".UDvariantContain .swt-type-image .available").length <= 0){
            $(".UDvariantContain .swt-type-image .header").hide();
          }
          if($(".UDvariantContain .swt-type-color .available").length <= 0){
            $(".UDvariantContain .swt-type-color .header").hide();
          }
          if($(".UDvariantContain .swt-type-button .available").length <= 0){
            $(".UDvariantContain .swt-type-button .header").hide();
          }
          $(".UDvariantContain .swt-type-image .available input,.UDvariantContain .swt-type-color  .available input").prop("checked",false)
        }
      	$(".UDprinterSelectBox .size, .UDprinterSelectBox .color, .UDprinterSelectBox .colour").hide();
    })
    
    $(".UDvariantContain .swt-type-button .available label").click(function(){   
      $(".detail-price").show();
      	setTimeout(function(){ 
          
          if($(".UDvariantContain .swt-type-image .available,.UDvariantContain .swt-type-color  .available").length > 0){
            $(".UDvariantContain .swt-type-image .header,.UDvariantContain .swt-type-color  .header").show();
          }
          
          $(".UDvariantContain .swt-type-image .available,.UDvariantContain .swt-type-color  .available").show(); 
          $(".UDvariantContain .swt-type-image .soldout,.UDvariantContain .swt-type-color  .soldout").hide();          
          //$(".product-detail_price-element").html(price);  
          $(".UDvariantContain .swt-type-image .available input,.UDvariantContain .swt-type-color  .available").prop("checked",false)
        }, 500);      			
    })        
    
});


// $( document ).ready(function() {
//   var price = $(".product-detail_price-element").html();
//     $(".UDvariantContain div, .UDcartActionBtn").hide();
//     var printerGetInt = setInterval(function(){
//       if($(".UDprinterSelectBox .printer").length > 0){
//       	$(".UDprinterSelectBox .printer select").prepend('<option value="0" selected>Please select...</option>')
//         $(".UDprinterSelectBox").show();
//         $(".UDprinterSelectBox .printer select").addClass("UDprinterSlectOpt");
//         clearInterval(printerGetInt);
//       }
//     },1000);
  
//     $(document).on("change",".UDprinterSlectOpt",function(){
//         setTimeout(function(){ 
// 			if(this.value == 0){
//               $(".UDvariantContain div, .UDcartActionBtn").hide();          
//               $(".UDprinterSelectBox, .UDprinterSelectBox .printer").show();           
//               $(".UDvariantContain .swt-type-image .available").show();
//               $(".UDvariantContain .swt-type-button  .available").show();
//               if($(".UDvariantContain .swt-type-image .available").length > 0){
//                 $(".UDvariantContain .swt-type-image .header").show();
//               }
//               if($(".UDvariantContain .swt-type-button .available").length > 0){
//                 $(".UDvariantContain .swt-type-button .header").show();
//               }
//               $(".product-detail_price-element").html(price);
//             }else{          
//               $(".UDvariantContain div, .UDcartActionBtn").show();
//               $(".UDvariantContain .swt-type-image .soldout").hide();
//               $(".UDvariantContain .swt-type-button  .soldout").hide();
//               $(".UDvariantContain .swt-type-image .available").show();
//               $(".UDvariantContain .swt-type-button  .available").show();
// 			  if($(".UDvariantContain .swt-type-image .available").length <= 0){
//                 $(".UDvariantContain .swt-type-image .header").hide();
//               }
//               if($(".UDvariantContain .swt-type-button .available").length <= 0){
//                 $(".UDvariantContain .swt-type-button .header").hide();
//               }

//               $(".product-detail_price-element").html(price);            
//             }
//           $(".UDprinterSelectBox .size, .UDprinterSelectBox .color").hide();
//         }, 500);        
//     })
// });